import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Helper to build full file URL from stored storage path or API-relative url
export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  // storage_path returned from /api/upload (no leading slash, like "atc-home-pros/...")
  return `${API}/files/${pathOrUrl}`;
}

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_atc-builder/artifacts/85i0cjbr_Photo%20Mar%2017%202026%2C%208%2008%2051%20PM%20%281%29.png";

export const HERO_IMG =
  "https://images.unsplash.com/photo-1772567732969-c1506edf80a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwcmVtb2RlbHxlbnwwfHx8fDE3Nzc5ODQ4ODR8MA&ixlib=rb-4.1.0&q=85";

export const DECK_IMG =
  "https://images.unsplash.com/photo-1721134115634-ab794ccfc81e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwbW9kZXJuJTIwaG9tZSUyMGRlY2slMjBhZGRpdGlvbnxlbnwwfHx8fDE3Nzc5ODQ4ODR8MA&ixlib=rb-4.1.0&q=85";

export const CONCRETE_IMG =
  "https://images.unsplash.com/photo-1633319987325-aae32f3d8dd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxkYXJrJTIwY29uY3JldGUlMjB0ZXh0dXJlJTIwcGF0dGVybnxlbnwwfHx8fDE3Nzc5ODQ4ODl8MA&ixlib=rb-4.1.0&q=85";

// Image mapping per service slug — used until admin uploads custom images
export const SERVICE_IMG = {
  "custom-decks": DECK_IMG,
  "custom-kitchens": HERO_IMG,
  "bathroom-remodeling":
    "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1600&q=80",
  roofing:
    "https://images.unsplash.com/photo-1632823471406-4c5c7fe10475?auto=format&fit=crop&w=1600&q=80",
  "siding-gutters":
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1600&q=80",
  "additions-remodels":
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80",
};

export function serviceImage(svc) {
  if (!svc) return HERO_IMG;
  if (svc.image_path) return fileUrl(svc.image_path);
  return SERVICE_IMG[svc.slug] || HERO_IMG;
}
